import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HistoricalTrendsComponent } from './components/historical-trends-at-a-glance/historical-trends.component';
import { HistoricalTrendsTransitionComponent } from './components/historical-trends-transition/historical-trends-transition.component';
import { HistoricalTrendsInsightsComponent } from './components/historical-trends-insights/historical-trends-insights.component';
import { HistoricalTrendsReportsComponent } from './components/historical-trends-reports/historical-trends-reports.component';
import { HistoricalTrendsUpgradeComponent } from './components/historical-trends-upgrade/historical-trends-upgrade.component';
import { StreamgraphVolPerLevelComponent } from './components/streamgraph-vol-per-level/streamgraph-vol-per-level.component';
import { HistoricalInsightGeographicComponent } from './components/historical-trends-insights/hist-insights-geo/historical-insights-geographic.component';
import { AuthGuardService } from '../shared/services/auth-guard.service';
import { HeadcountTrendsComponent } from './components/headcount-trends/headcount-trends.component';

const historicalTrendsRoutes: Routes = [
    { path: '', component: HistoricalTrendsTransitionComponent },
    {
        path: 'at-a-glance',
        component: HistoricalTrendsComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights',
        component: HistoricalTrendsInsightsComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'report-menu',
        component: HistoricalTrendsReportsComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights',
        component: HistoricalTrendsInsightsComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights/streamgraph-vol-per-level',
        component: StreamgraphVolPerLevelComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights/geographic',
        component: HistoricalInsightGeographicComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights/headcount-trends',
        component: HeadcountTrendsComponent,
        canActivate: [AuthGuardService],
    },
    { path: 'upgrade', component: HistoricalTrendsUpgradeComponent },
];

@NgModule({
    imports: [RouterModule.forChild(historicalTrendsRoutes)],
    exports: [RouterModule],
})
export class HistoricalTrendsRoutingModule {}
